import MDButton from 'components/MDButton';
import React, { useEffect, useState } from 'react';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { Select, MenuItem, OutlinedInput } from '@mui/material';
import { useAppServices } from 'hook/services';
import { useAgencyInfo } from 'context/agency';
import MDInput from 'components/MDInput';

const EditModal = ({ data, handleRefresh }) => {
  const [agency] = useAgencyInfo();
  const AppService = useAppServices();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [allApps, setAllApps] = useState([]);
  const [selectedApps, setSelectedApps] = useState([]);
  const [selectedAppTypes, setSelectedAppTypes] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const getApps = async () => {
      const { response } = await AppService.app.get();
      if (isMounted && response) {
        setAllApps(response.data);
      }
    };

    getApps();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (data?.apps) {
      setSelectedApps(data.apps);
    }
    if (data?.app_type) {
      setSelectedAppTypes(data.app_type);
    }
  }, [data]);

  const handleModal = () => {
    setOpenEditModal(true);
  };

  function EditProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false);

    const handleSubmit = async (e) => {
      e.preventDefault();

      const payload_data = {
        name: e.target.name.value,
        apps: selectedApps,
        app_type: selectedAppTypes,
      };

      const payload = {
        data: payload_data,
      };

      const { response } = await AppService.ActionsCategories.update({
        payload: payload,
        id: data._id,
      });

      if (response) {
        setProcessing(false);
        onClose();
        handleRefresh();
      }
    };

    const handleChangeApps = (event) => {
      const { value } = event.target;
      setSelectedApps(typeof value === 'string' ? value.split(',') : value);
    };

    const handleChangeAppTypes = (event) => {
      const { value } = event.target;
      setSelectedAppTypes(typeof value === 'string' ? value.split(',') : value);
    };

    const appsTypes = [
      { label: 'Payment Provider', value: 'payment_provider' },
      { label: 'Conversation Provider', value: 'conversation_provider' },
      { label: 'Actions', value: 'actions' },
      { label: 'Triggers', value: 'triggers' },
      { label: 'Custom JS', value: 'custom_js' },
      { label: 'Custom Page', value: 'custom_page' },
      { label: 'Widget', value: 'widget' },
      { label: 'Snapshot', value: 'snapshot' },
    ];

    return (
      <MDModal open={open} onClose={onClose}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={{ p: 4, width: 400 }}>
            <MDTypography variant="h5" mb={2}>
              Edit Apps Collection
            </MDTypography>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Name
              </MDTypography>
              <MDInput label="Name" placeholder="Name" name="name" fullWidth defaultValue={data.name} />
            </MDBox>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Select Apps
              </MDTypography>
              <Select
                fullWidth
                multiple
                name="apps"
                value={selectedApps}
                onChange={handleChangeApps}
                input={<OutlinedInput label="Select Apps" />}
              >
                {allApps?.map((app) => (
                  <MenuItem key={app?.app_id} value={app?.app_id}>
                    {app?.name}
                  </MenuItem>
                ))}
              </Select>
            </MDBox>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                App Type
              </MDTypography>
              <Select
                fullWidth
                multiple
                name="app_type"
                value={selectedAppTypes}
                onChange={handleChangeAppTypes}
                input={<OutlinedInput label="App Type" />}
              >
                {appsTypes.map((type) => (
                  <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
                ))}
              </Select>
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton variant="gradient" color="primary" type="button" sx={{ mt: 4, mb: 1 }} onClick={onClose}>
                Close
              </MDButton>
              <MDButton variant="gradient" color="info" type="submit" sx={{ mt: 4, mb: 1, ml: 1 }} loading={processing} disabled={processing}>
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    );
  }

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <EditProduct open={openEditModal} onClose={() => setOpenEditModal(false)} />
    </>
  );
};

export default EditModal;
